import React, { useEffect } from 'react';
import { MovingHomePendingCard } from '../MovingHomePendingCard/MovingHomePendingCard';
import { WhatsNextCard } from '../WhatsNextCard/WhatsNextCard';
import { Stack } from '@ovotech/element-v4';
import { WantToTakeOvoWithYouCard } from '../WantToTakeOvoWithYouCard/WantToTakeOvoWithYouCard';
import { formatMoveOutAddress } from '@/src/pages/MovingHome/utils/formatMoveOutAddress';
import { formatMoveOutDate } from '@/src/pages/MovingHome/utils/formatMoveOutDate';
import { toDate } from '../../utils/movingDateValuesConversion';
import { useAnalytics } from '@ovotech/ui-tools';
import { HOME_MOVES_IN_PROGRESS } from '@/src/constants/analytics-subjects';
import { HomeMovesCustomerData } from '@/src/api/home-moves';
import { isCotMoveInTooFarInTheFuture } from '../../utils/cotMoveIn';

/**
 * MovingHomeConfirmWithData component.
 * Displays confirmation details after a move out date has been set.
 * It renders the MovingHomePendingCard and WhatsNextCard components.
 *
 * @param {object} props - The component props.
 * @param {HomeMovesCustomerData} [props.moveOutCustomer] - Data about the move out customer.
 * @param {string} props.moveOutDate - The confirmed move out date.
 */
export const MovingHomeConfirmWithData = ({
  moveOutCustomer,
  moveOutDate,
  isTakingOvo,
  newAddressIsCot,
}: {
  moveOutCustomer?: HomeMovesCustomerData;
  moveOutDate: string;
  isTakingOvo: boolean;
  newAddressIsCot: boolean;
}) => {
  const { dispatch } = useAnalytics();

  const address = formatMoveOutAddress(moveOutCustomer);
  const moveDate = toDate({
    date: formatMoveOutDate(moveOutDate),
  });

  const showWantToTakeOvoCard =
    !!address &&
    !isTakingOvo &&
    !(
      newAddressIsCot && isCotMoveInTooFarInTheFuture(newAddressIsCot, moveDate)
    );

  useEffect(() => {
    dispatch({
      type: 'view',
      name: HOME_MOVES_IN_PROGRESS,
    });
  }, [dispatch]);

  return (
    <Stack spaceBetween={[5, 6, 6]}>
      <MovingHomePendingCard
        address={address}
        initialMovingDate={moveOutDate}
        isTakingOvo={isTakingOvo}
        newAddressIsCot={newAddressIsCot}
      />
      <WhatsNextCard date={moveOutDate} />
      {showWantToTakeOvoCard && <WantToTakeOvoWithYouCard />}
    </Stack>
  );
};
